export const getChannelsBackgroundUrl = (language: string) => {
    switch (language) {
        default:
            return 'https://avatars.mds.yandex.net/get-ott/374297/2a0000019a33f63ffe58da1a43554a100922/orig';
    }
};
